import { getIdNumber } from 'utils/userIdRole.js';

function schoolRoleParser(payload) {
  const members = { list: [] };
  payload.members?.forEach((member) => {
    const id = getIdNumber(member);
    members[id] = member;
    members.list.push(id);
  });
  return { ...payload, members };
}

export default schoolRoleParser;
